export const iconFontAwesomeHumanitarianTrowelBricks = (
	<i className="fa-solid fa-trowel-bricks"></i>
);
